let elements = {
  //pick: 3,
  blockCheck: true,
  permanent: true,
  mainImage: {
    imagePath: 'games/page018_game0/img/bcg.webp',
    pos: {
      y: 0,
      x: 0,
    },
    width: 1920,
  },
  audio: {
    negative: 'games/page018_game0/audio/false.mp3',
    positive: 'games/page018_game0/audio/25_brother.mp3',
    click: 'games/page018_game0/audio/click.mp3',
    icon: {
      on: 'games/page018_game0/img/audioOn.png',
      off: 'games/page018_game0/img/audioOff.png',
    },
  },
  itemsConfig: {
    width: 60,
    height: 60,
    background: 'transparent',
  },
  correctItemsConfig: {
    width: 165,
    height: 305,
  },
  layoutItems: [
    {
      pos: {
        x: 96,
        y: 96,
      },
    },
  ],
  layoutCorrectItems: [
    {
      pos: {
        x: 1381,
        y: -15,
      },
    },
    {
      pos: {
        x: 867,
        y: -15,
      },
    },
    {
      pos: {
        x: 1381,
        y: 424,
      },
    },
    {
      pos: {
        x: 867,
        y: 424,
      },
    },
  ],
  shuffle: false,
  shuffleCorrect: false,
  shuffleGroups: false,
  shuffleInsideItems: true,
  pick: 0,
  falseStatus: true,
  groups: [
    {
      items: [
        {
          audioSrc: 'games/page018_game0/audio/25_brother.mp3',
          correct: {
            audioId: 'a01',
            image: {
              src: 'games/page018_game0/img/2.png',
            },
            width: 481,
            height: 425,
            correctItems: {
              images: [
                {
                  src: 'games/page018_game0/img/good.png',
                  pos: {
                    y: 0,
                    x: 0,
                  },
                  width: 481,
                  height: 425,
                },
              ],
              text: [],
            },
          },
        },
        {
          alwaysCorrect: true,
          correct: {
            audioId: 'a02',
            image: {
              src: 'games/page018_game0/img/1.png',
            },
            width: 481,
            height: 425,
            incorrectItems: {
              images: [
                {
                  src: 'games/page018_game0/img/wrong.png',
                  pos: {
                    y: 0,
                    x: 0,
                  },
                  width: 481,
                  height: 425,
                },
              ],
              text: [],
            },
          },
        },
        {
          alwaysCorrect: true,
          correct: {
            audioId: 'a03',
            image: {
              src: 'games/page018_game0/img/3.png',
            },
            width: 481,
            height: 425,
            incorrectItems: {
              images: [
                {
                  src: 'games/page018_game0/img/wrong.png',
                  pos: {
                    y: 0,
                    x: 0,
                  },
                  width: 481,
                  height: 425,
                },
              ],
              text: [],
            },
          },
        },
        {
          alwaysCorrect: true,
          correct: {
            audioId: 'a04',
            image: {
              src: 'games/page018_game0/img/4.png',
            },
            width: 481,
            height: 425,
            incorrectItems: {
              images: [
                {
                  src: 'games/page018_game0/img/wrong.png',
                  pos: {
                    y: 0,
                    x: 0,
                  },
                  width: 481,
                  height: 425,
                },
              ],
              text: [],
            },
          },
        },
      ],
    },
  ],
  mbAudioItemData: [
    {
      maskConfig: {
        click: { src: 'games/page018_game0/audio/click.mp3' },
        src: 'games/page018_game0/img/folia.png',
        cssStyle: {
          'margin-left': '0px',
          'margin-top': '0px',
        },
      },
      id: 'a01',
      src: 'games/page018_game0/audio/click.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page018_game0/img/audioOn.png', iconOff: 'games/page018_game0/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 18,
        x: 295,
      },
      width: '46px',
      height: '46px',
      unit: 'px',
      cssStyle: { width: 0, height: 0 },
    },
    {
      maskConfig: {
        click: { src: 'games/page018_game0/audio/click.mp3' },
        src: 'games/page018_game0/img/folia.png',
        cssStyle: {
          'margin-left': '0px',
          'margin-top': '0px',
        },
      },
      id: 'a02',
      src: 'games/page018_game0/audio/click.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page018_game0/img/audioOn.png', iconOff: 'games/page018_game0/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 18,
        x: 295,
      },
      width: '46px',
      height: '46px',
      unit: 'px',
      cssStyle: { width: 0, height: 0 },
    },
    {
      maskConfig: {
        click: { src: 'games/page018_game0/audio/click.mp3' },
        src: 'games/page018_game0/img/folia.png',
        cssStyle: {
          'margin-left': '0px',
          'margin-top': '0px',
        },
      },
      id: 'a03',
      src: 'games/page018_game0/audio/click.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page018_game0/img/audioOn.png', iconOff: 'games/page018_game0/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 18,
        x: 295,
      },
      width: '46px',
      height: '46px',
      unit: 'px',
      cssStyle: { width: 0, height: 0 },
    },
    {
      maskConfig: {
        click: { src: 'games/page018_game0/audio/click.mp3' },
        src: 'games/page018_game0/img/folia.png',
        cssStyle: {
          'margin-left': '0px',
          'margin-top': '0px',
        },
      },
      id: 'a04',
      src: 'games/page018_game0/audio/click.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page018_game0/img/audioOn.png', iconOff: 'games/page018_game0/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 18,
        x: 295,
      },
      width: '46px',
      height: '46px',
      unit: 'px',
      cssStyle: { width: 0, height: 0 },
    },
  ],
  // staticMaskConfig: [
  //   {
  //     id: 'm1',
  //     pos: {
  //       x: 1162,
  //       y: 3,
  //     },
  //     unit: 'px',
  //     click: { src: 'games/page018_game0/audio/click.mp3' },
  //     src: 'games/page018_game0/img/folia.png',
  //   },
  //   {
  //     id: 'm2',
  //     pos: {
  //       x: 1676,
  //       y: 3,
  //     },
  //     unit: 'px',
  //     click: { src: 'games/page018_game0/audio/click.mp3' },
  //     src: 'games/page018_game0/img/folia.png',
  //   },
  //   {
  //     id: 'm3',
  //     pos: {
  //       x: 1162,
  //       y: 442,
  //     },
  //     unit: 'px',
  //     click: { src: 'games/page018_game0/audio/click.mp3' },
  //     src: 'games/page018_game0/img/folia.png',
  //   },
  //   {
  //     id: 'm4',
  //     pos: {
  //       x: 1676,
  //       y: 442,
  //     },
  //     unit: 'px',
  //     click: { src: 'games/page018_game0/audio/click.mp3' },
  //     src: 'games/page018_game0/img/folia.png',
  //   },
  // ],
  mbStaticAudioItemData: [
    {
      src: 'games/page018_game0/audio/24_sister.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page018_game0/img/audioOn.png', iconOff: 'games/page018_game0/img/audioOff.png' },
        fill: 'none',
      },
      width: '46px',
      height: '46px',
      pos: {
        y: 707,
        x: 178 - 6,
      },
      unit: 'px',
    },
    {
      src: 'games/page018_game0/audio/22_mummy.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page018_game0/img/audioOn.png', iconOff: 'games/page018_game0/img/audioOff.png' },
        fill: 'none',
      },
      width: '46px',
      height: '46px',
      pos: {
        y: 705,
        x: 321 - 36,
      },
      unit: 'px',
    },
    {
      src: 'games/page018_game0/audio/23_daddy.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page018_game0/img/audioOn.png', iconOff: 'games/page018_game0/img/audioOff.png' },
        fill: 'none',
      },
      width: '46px',
      height: '46px',
      pos: {
        y: 703,
        x: 451 - 6,
      },
      unit: 'px',
    },
    {
      src: 'games/page018_game0/audio/25_brother.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page018_game0/img/audioOn.png', iconOff: 'games/page018_game0/img/audioOff.png' },
        fill: 'none',
      },
      width: '46px',
      height: '46px',
      pos: {
        y: 701,
        x: 588 - 6,
      },
      unit: 'px',
    },
    {
      src: 'games/page018_game0/audio/26_baby.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page018_game0/img/audioOn.png', iconOff: 'games/page018_game0/img/audioOff.png' },
        fill: 'none',
      },
      width: '46px',
      height: '46px',
      pos: {
        y: 705,
        x: 375 - 36,
      },
      unit: 'px',
    },
  ],
};

export default elements;
